import { NavLink } from 'react-router';
import { haptic } from '~/lib/native';

type TabUser = { email: string; role: string } | null;

const IconCalendar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true">
    <rect x="3" y="4.5" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M3 9h18M8 2.5v4M16 2.5v4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
const IconList = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true">
    <rect x="3.5" y="3.5" width="17" height="17" rx="2.5" stroke="currentColor" strokeWidth="1.8" />
    <path d="M12 8.5v7M8.5 12h7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);
const IconAccount = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true">
    <circle cx="12" cy="8" r="3.5" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M4.5 20c0-3.6 3.4-6 7.5-6s7.5 2.4 7.5 6"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
const IconMore = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="none" aria-hidden="true">
    <circle cx="5" cy="12" r="1.6" fill="currentColor" />
    <circle cx="12" cy="12" r="1.6" fill="currentColor" />
    <circle cx="19" cy="12" r="1.6" fill="currentColor" />
  </svg>
);

/**
 * Fixed bottom tab bar — the app's primary nav (replaces the website header when
 * running in the native shell). Haptic tap feedback; safe-area aware in CSS.
 */
export function BottomTabBar({ user }: { user: TabUser }) {
  const tap = () => void haptic();
  return (
    <nav className="tab-bar" aria-label="Primary">
      <NavLink to="/" end className="tab-item" onClick={tap}>
        <IconCalendar />
        <span>Calendar</span>
      </NavLink>
      <NavLink to="/submit" className="tab-item" onClick={tap}>
        <IconList />
        <span>List</span>
      </NavLink>
      <NavLink to={user ? '/account' : '/join'} className="tab-item" onClick={tap}>
        <IconAccount />
        <span>{user ? 'Account' : 'Sign in'}</span>
      </NavLink>
      <NavLink to="/more" className="tab-item" onClick={tap}>
        <IconMore />
        <span>More</span>
      </NavLink>
    </nav>
  );
}
